import {createSelector} from 'reselect'
import {generatePath} from '@modifi/router'
import {FeInputFieldStatus} from '@modifi/enums'

import {selectCompanyIsLocked} from '../../../../data/company'
import {selectCombinedInputFieldStatusBySectionName} from '../../../../modules/input-fields'
import {ROUTE_COMPANY_PROFILE_LEGAL_REPRESENTATIVES_BY_ID} from '../../../../routes/constants'
import {selectLegalRepresentatives} from '../../../../data/legal-representatives'
import DeleteLegalRepButton from '../../../../features/delete-legal-representative'
import {SECTION_LEGAL_REPRESENTATIVES} from '../../../../constants/sections'

export const selectLegalRepSummaryData = createSelector(
  selectLegalRepresentatives,
  selectCompanyIsLocked,
  (state: Record<string, any>) => state,
  (legalReps, companyIsLocked, state) => {
    const isVerified =
      selectCombinedInputFieldStatusBySectionName(state, SECTION_LEGAL_REPRESENTATIVES) ===
      FeInputFieldStatus.VERIFIED
    const summaryData = legalReps.map(legalRep => {
      const name = `${legalRep?.firstName} ${legalRep?.lastName} `
      return {
        route: generatePath(ROUTE_COMPANY_PROFILE_LEGAL_REPRESENTATIVES_BY_ID, {
          externalId: legalRep?.externalId,
        }),
        name,
        position: legalRep?.position || '',
        deleteButton: companyIsLocked || isVerified ? undefined : DeleteLegalRepButton,
        deleteProps: {target: name, externalPersonId: legalRep?.externalId},
      }
    })
    return summaryData
  }
)
